const Navigation = ({ question, totalQuestions, showError, onChange, reset, settings }) => {

    var style = { height: '100%', backgroundColor: '#145e9d', textAlign: 'left' };

    return <div className="actions">
        <div className="progressBar"><div style={{ ...style, width: question > 0 ? `${(question * 100) / totalQuestions}%` : '0%' }} className="step01"></div></div>
        <div className="action-elements" >
            {showError === true &&
                <div className="error-container">
                    <span className="errorMessage">*Ingrese un dato válido</span>
                </div>
            }
            <div className="buttons">
                {question > 0 && <button onClick={() => onChange(false)} className="previousstep">Regresar</button>}
                {question > 0 && question >= totalQuestions ?
                    <button onClick={() => reset()} className="nextstep">Inicio</button> :
                    <button onClick={() => onChange()} className="nextstep">Siguiente</button>
                }
            </div>
        </div>
    </div>;
}

export default Navigation;